// Code d'invitation conservé le temps d'une connexion ou d'une inscription
// (spec ambassadeurs §4) : sessionStorage, jamais bloquant si indisponible.
const KEY = 'myfood:invitation';

export function memoriserInvitation(code: string): void {
  try { sessionStorage.setItem(KEY, code.trim().toUpperCase()); } catch { /* stockage indisponible */ }
}
export function lireInvitation(): string | null {
  try { return sessionStorage.getItem(KEY); } catch { return null; }
}
export function oublierInvitation(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* rien */ }
}
